let apiUrl = 'http://106.15.187.217:8080/pmrest' // 接口域名
// let apiUrl = 'http://192.168.16.243:9090/pmrest' // 接口域名
if (location.host.indexOf('localhost') >= 0) {
  apiUrl = '/pmrest'
  // apiUrl = 'http://192.168.16.243:9090/pmrest'
} else if (location.host.indexOf('pm.xb969.com') >= 0) {
  // 部署在 https://pm.xb969.com/pm/login 时，接口请求地址为 https://pm.xb969.com/pmrest
  apiUrl = 'https://pm.xb969.com/pmrest'
} else if (location.host.indexOf('106.15.187.217:8085') >= 0) {
  // 部署在 http://106.15.187.217:8085/pm/login 时，接口请求地址为 http://106.15.187.217:8080/pmrest
  apiUrl = 'http://106.15.187.217:8080/pmrest'
} else if (location.host.indexOf('garcia.xb969.com') >= 0) {
  apiUrl = 'https://garcia.xb969.com/pmrest'
}

// 接口域名s
const apiDomain = apiUrl
// 接口返回状态码
const resCode = {
  ERR_OK: 1000,
  ERR_EX: 1005,
  ERR_OR: 1006,
  ERR_XS: 2000,
  ERR_RF: 1004,
  ERR_NR: 1007,
  ERR_NL: 1008,
  ERR_DS: 1009,
  ERR_TIMEOUT: 1015, // refreshToken 过期
  ERR_DE: 51101 // 停用岗位-当前有任务-需要用户二次确认
}
const rootFile = ''
/* 返回值 */
function upSwitch (res) {
  switch (res.data.code) {
    case resCode.ERR_OK:
      return res.data
  }
}

// 显示条数
const pageSize = 10
export {
  apiDomain,
  resCode,
  pageSize,
  upSwitch,
  rootFile
}



// WEBPACK FOOTER //
// ./src/api/config.js